import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { PageHeader } from "@/components/storefront/PageHeader";
import { Seo } from "@/components/Seo";
import { Skeleton } from "@/components/ui/skeleton";
import { API } from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    API.get("/testimonials").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="testimonials-page">
      <Seo title="Testimonials | Eileen Jenkins Florist" description="What our customers say about our flowers and service." />
      <PageHeader title="Kind Words" subtitle="We're proud to have been part of so many special moments across the valleys." testId="testimonials-header" />
      <div className="max-w-5xl mx-auto px-4 pb-16">
        {items === null ? (
          <div className="grid md:grid-cols-2 gap-6">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-40 rounded-xl" />)}</div>
        ) : items.length === 0 ? (
          <p className="text-center text-muted-foreground py-12" data-testid="testimonials-empty">No testimonials yet.</p>
        ) : (
          <div className="grid md:grid-cols-2 gap-6" data-testid="testimonials-grid">
            {items.map((t, i) => (
              <motion.blockquote
                key={t.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: Math.min(i * 0.08, 0.4) }}
                className="rounded-xl border bg-card p-7"
                data-testid={`testimonial-${t.id}`}
              >
                <p className="font-accent text-xl italic leading-relaxed">“{t.text}”</p>
                <footer className="mt-4 text-sm">
                  <span className="font-semibold">{t.name}</span>
                  {t.category && <span className="text-muted-foreground"> · {t.category}</span>}
                  {t.date && <span className="text-muted-foreground"> · {t.date}</span>}
                </footer>
              </motion.blockquote>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
